import React from 'react'
import './Intro.css'

class Intro extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            circlesMap: [],
            lastScreenSize: {
                width: 0,
                height: 0,
            },
            updateNeeded: false,
        }

        
    }

    


    componentDidMount() {
        setInterval(() => {
            this.initBackground(this.state.lastScreenSize.width, this.state.lastScreenSize.height)
        }, 2000);
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (this.props.width > this.state.lastScreenSize.width + 50 ||
            this.props.width < this.state.lastScreenSize.width - 50 ||
            this.props.height > this.state.lastScreenSize.height + 50 ||
            this.props.height < this.state.lastScreenSize.height - 50)
                this.initBackground(this.props.width, this.props.height)
    }

    initBackground = (width, height) => {
        const svgWidth = width * 0.8;
        const svgHeight = height * 0.6;

        const circlesArray = []
        Array(10).fill(null).map((v, i) => {
            const cx = Math.random() * svgWidth;
            const cy = Math.random() * svgHeight;
            circlesArray[i] = { cx: cx, cy: cy };
            return <circle cx={cx} cy={cy} r="6" fill="#C4C4C4" key={i} />
        })
        

        this.setState({ 
            updateNeeded: false, 
            circlesMap: circlesArray,
            lastScreenSize: {
                width: width,
                height: height,
            } })
    }

    

    render() {
        let circles = null;
        let connections = null;
        const svgWidth = this.props.width * 0.8;
        const svgHeight = this.props.height * 0.6;
        const svgStyle = { width: svgWidth + "px", height: svgHeight + "px" };

        circles = this.state.circlesMap.map((v, i) => {
            return <circle cx={v.cx} cy={v.cy} r="6" fill="#C4C4C4" key={i} />
        })

        connections = this.state.circlesMap.map((c, i) => {
            return this.state.circlesMap.map((innerC, innerI) => {
                const d = "M" + c.cx + " " + c.cy + " L" + innerC.cx + " " + innerC.cy;
                
                return <path
                    d={d}
                    key={i + "_" + innerI}
                    stroke="#C4C4C4"
                     />

                /* return <line
                    x1={this.state.circlesMap[i].cx}
                    y1={this.state.circlesMap[i].cy}
                    x2={this.state.circlesMap[innerI].cx}
                    y2={this.state.circlesMap[innerI].cy}
                    key={i + "_" + innerI}
                    stroke="#C4C4C4" /> */
            })
        })

        return (
            <div className="intro-layout">
                <svg width={svgWidth} height={svgHeight} style={svgStyle}>
                    {circles}
                    {connections}
                </svg>
                <p className="sub-title">We Create</p>
                <p className="title">APPS</p>
            </div>
        )
    }

}

export default Intro
